import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class UserToCaseAssignmentModel extends BaseModel {
  static urlPath = "user_case";

  @attr("boolean") archived;
  @attr("boolean") canEdit;
  @attr("number") case;
  @attr("datetime") createdAt;
  @attr("json") createdBy;
  @attr("json") role;
  @attr("datetime") updatedAt;
  @attr("json") updatedBy;
  @attr("json") user;
}
